export const USER_INPUT_PLACEHOLDER = "{user_input}";
export const USER_INPUT_FALLBACK = "YOUR_TEXT_HERE";
